export const billingKeys = {
  all: ['billing'] as const,
  /** `tenantId` is `null` before the current user's tenant is known — the query stays `enabled: false` then. */
  own: (tenantId: string | null): readonly (string | null)[] => [...billingKeys.all, 'own', tenantId] as const,
};
